<template>
  <div>
    <el-dialog  :visible.sync="centerDialogVisible" top="20vh" width="25%">
      <div class="content">
        <img :src="QrImgUrl" class="qr-img">
        <div class="tip">微信扫码，布置课前预习、课后复习任务、查看作业测评报告</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'QRcode',
  data () {
    return {
      QrImgUrl: require('../assets/wx_psh_teacher_qrcode.png'),
      centerDialogVisible: false
    }
  },
  methods: {
    show () {
      this.centerDialogVisible = true
    }
  }
}
</script>
<style scoped>
.content{
  text-align: center;

  .qr-img{
    display:block;
    width:100%;
  }
}
.tip{
  margin: 20px;
}
</style>
